<template>
  <div class="coach-card-view" v-if="coachData != undefined && coachData != null">
    <template v-if="index == 0">
      <h4 style="margin-bottom: 15px;">证书{{index + 1}}</h4>
      <div v-if="index == 0" style="margin-bottom: 15px;font-size: 12px;color: #666;">
        （该证书为您的主资格证书，将在协会认证教练员列表优先展示）
      </div>
    </template>

    <h4 v-else style="margin-bottom: 30px;">证书{{index + 1}}</h4>
    <div class="input-row" :id="'certificate_' + coachData.uuid + '_name_view'">
      <div class="column left-label">*证书名称
        <a class="iconfont" style="text-decoration: none;color: #333;font-size: 12px;" href="javascript:void(null);"
          data-container="body" data-html="true" data-placement="hover focus click" :data-content="topNoticeContent"
          data-trigger="hover focus" data-toggle="popover">&#xe659;</a>

        ：</div>
      <div class="column">
        <el-select :class="[ (noticed && !coachData.name) ? 'red-border' : '']" placeholder="请选择证书名称" v-model="nameItemIndex"
          @change="certNameChanged">
          <el-option v-for="(item, index) in nameList" :key="'name_select_' + index" :label="item" :value="index" />
        </el-select>
      </div>
    </div>

    <div class="input-row" :id="'certificate_' + coachData.uuid + '_level_view'">
      <div class="column left-label">*证书等级：</div>
      <div class="column">
        <el-select v-if="levelList[nameIndex].length > 0" :class="[ (noticed && !coachData.level) ? 'red-border' : '']"
          placeholder="请选择证书等级" v-model="levelItemIndex" @change="levelsChanged">
          <el-option v-for="(item, index) in levelList[nameIndex]" :key="'level_select_' + index" :label="item" :value="index" />
        </el-select>
        <el-input v-else :class="[ (noticed && !coachData.level) ? 'red-border' : '']" v-model="coachData.level"
          clearable placeholder="请填写证书名称及等级" />
      </div>
    </div>

    <div class="input-row" :id="'certificate_' + coachData.uuid + '_sn_view'">
      <div class="column left-label">*证书编号：</div>
      <div class="column">
        <el-input :class="[ (noticed && !coachData.sn) ? 'red-border' : '']" v-model="coachData.sn" placeholder="请输入证书编号"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'certificate_' + coachData.uuid + '_strDateOfIssue_view'">
      <div class="column left-label">*证书签发日期：</div>
      <div class="column">
        <el-date-picker clearable :class="[ (noticed && !coachData.strDateOfIssue) ? 'red-border' : '']" v-model="coachData.strDateOfIssue"
          :picker-options="pickerOptions" align="right" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="请选择签发日期">
        </el-date-picker>
      </div>
    </div>

    <div class="input-row" :id="'certificate_' + coachData.uuid + '_unit_view'">
      <div class="column left-label">*发证单位：</div>
      <div class="column">
        <el-input :class="[ (noticed && !coachData.unit) ? 'red-border' : '']" v-model="coachData.unit" placeholder="以证书落款印鉴为准"
          clearable />
      </div>
    </div>

    <div class="input-row" :id="'certificate_' + coachData.uuid + '_photos_view'">
      <div class="column left-label picuture-upload-label">*证书照片：</div>
      <div class="column">
        <el-upload :class="[ (noticed && coachData.photos.length == 0) ? 'red-border' : '', 'files-upload']" action="https://api.shslqxh.com/upload/files"
          :headers="headers" name="files" :limit="fileLimit" :file-list="initialFileList" :accept="acceptTypes"
          list-type="picture-card" :on-exceed="handleExceed" :on-remove="handleFileRemove" :before-remove="beforeRemoveFile"
          :on-preview="handlePreview" :on-success="handleUploadSuccess">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">请上传所有有效信息页。</div>
        </el-upload>
      </div>
    </div>
    <div v-if="index != 0"><a class="delete-button" href="javascript:void(0)" @click="deleteCardItem">删除</a></div>
    <image-preview-view v-if="dialogVisible" :picture-list="dialogImageModel.list" :initial-index="dialogImageModel.index"
      v-on:close="closeImagePreviewView" />
  </div>
</template>

<script>
  import ImagePreview from "../../../common/ImagePreview.vue";
  import PictureTool from "../../../../js/picture-tool.js";
  export default {
    name: 'coachCardItemVue',
    props: {
      coachData: {
        type: Object,
        default: null,
      },
      index: {
        type: Number,
        default: 0,
      },
      noticed: {
        type: Boolean,
        default: false,
      }
    },
    components: {
      'image-preview-view': ImagePreview
    },
    data() {
      return {
        headers: {},
        fileLimit: 10,

        dialogImageModel: null,
        dialogVisible: false,

        initialFileList: [],
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealDisableDate(time);
          }
        },
        nameList: [
          '篮球教练员职称',
          '社会体育指导员职业资格证书',
          '体育类教师资格证',
          '中国篮球协会教练员等级证',
          '境外篮球教练员证书',
          '其他体育职业技能等级证书'
        ],
        nameIndex: 0,
        nameItemIndex: null,
        levelItemIndex: null,
        levelList: [
          [
            '国家级',
            '高级',
            '中级',
            '初级'
          ],
          [
            '一级/高级技师',
            '二级/技师',
            '三级/高级',
            '四级/中级工',
            '五级/初级工'
          ],
          [
            '体育教师资格证',
          ],
          [
            'A级',
            'B级',
            'C级',
            'D级',
            'E级'
          ],
          [
            'FIBA3级',
            'FIBA2级',
            'FIBA1级',
            'FIBA Mini级',
            '其他境外篮球教练员等级'
          ],
          []
        ],
      }
    },
    computed: {
      topNoticeContent() {
        return "按照《上海市篮球协会教练员从业资质认证管理办法》之要求，本平台接受以下六类资格的教练员进行认证注册，包括：<br>1．体育教练员系列职称；<br>2．社会体育指导员职业资格证书；<br>3．体育类教师资格证；<br>4．全国性单项体育协会、本市市级单项体育协会及青少年人群<br>体育协会颁发的教练（员）等级证书；<br>5．经省级以上人力资源和社会保障部门备案的职业技能等级<br>评价机构颁发的体育职业技能等级证书；<br>6．经全国性单项体育协会或者本市市级单项体育协会专业水平转换认可的境外体育组织颁发的教练（员）证书。<br>";
      },
      acceptTypes() {
        return PictureTool.acceptTypes;
      },
    },
    mounted() {
      let token = this.$store.state.dataStore.getToken();
      this.headers.token = token;
      this.initData();
      setTimeout(function() {
        $("[data-toggle='popover']")
          .popover();
      }, 1000);
    },
    methods: {
      closeImagePreviewView() {
        this.dialogVisible = false;
        this.dialogImageModel = null;
      },
      initData() {
        let item = this.coachData;
        if (item == null) {
          return;
        }
        let initialFileList = [];
        if (item != null && item.photos.length > 0) {
          for (let i = 0; i < item.photos.length; i++) {
            initialFileList.push(item.photos[i])
          }
        }
        this.initialFileList = initialFileList;

        let name = this.coachData.name;
        let level = this.coachData.level;
        if (name == null || name == '') {
          this.nameIndex = 0;
        } else {
          let index = this.nameList.findIndex(function(item) {
            return name == item;
          });
          if (index == -1) {
            this.nameItemIndex = null;
            this.levelItemIndex = null;
            this.coachData.name = '';
            this.coachData.level = '';
            this.nameIndex = 0;
            return;
          }

          this.nameIndex = index;
          this.nameItemIndex = index;
          let levelIndex = this.levelList[index].findIndex(function(item) {
            return level == item;
          });
          if (levelIndex == -1) {
            this.coachData.level = '';
            this.levelItemIndex = null;
          } else {
            this.levelItemIndex = levelIndex;
          }
        }
      },
      dealDisableDate(time) {
        return new Date().getTime() - (new Date(time).getTime()) < 0;
      },

      changeShowIndex() {
        let nameItemIndex = this.nameItemIndex;
        let levelItemIndex = this.levelItemIndex;
        if (nameItemIndex == null || levelItemIndex == null) {
          return;
        }
        let showIndex = -1;

        if (nameItemIndex == 0) { // name == '篮球教练员职称'
          switch (levelItemIndex) {
            case 0:
              showIndex = 1;
              break;
            case 1:
              showIndex = 4;
              break;
            case 2:
              showIndex = 7;
              break;
            case 3:
              showIndex = 10;
              break;
            default:
              showIndex = -2;
          }
        }
        else if (nameItemIndex == 1) { // name == '社会体育指导员职业资格证书'
          switch (levelItemIndex) {
            case 0:
              showIndex = 3;
              break;
            case 1:
              showIndex = 6;
              break;
            case 2:
              showIndex = 9;
              break;
            case 3:
              showIndex = 12;
              break;
            case 4:
              showIndex = 14;
              break;
            default:
              showIndex = -3;
          }
        }
        else if (nameItemIndex == 2) { // name == '体育类教师资格证'
          showIndex = 15;
        }
        else if (nameItemIndex == 3 ) { // name == '中国篮球协会教练员等级证'
          switch (levelItemIndex) {
            case 0:
              showIndex = 2;
              break;
            case 1:
              showIndex = 5;
              break;
            case 2:
              showIndex = 8;
              break;
            case 3:
              showIndex = 11;
              break;
            case 4:
              showIndex = 13;
              break;
            default:
              showIndex = -5;
          }
        }
        else if ( nameItemIndex == 4 ) { // name == '境外篮球教练员证书'
          showIndex = 16;
        }
        else if (nameItemIndex == 5) { // name == '其他体育职业技能等级证书'
          showIndex = 17;
        }

        if (showIndex < 0) {
          this.$toast("数据异常");
        }
        this.coachData.showIndex = showIndex;
      },

      levelsChanged() {
        let levelItemIndex = this.levelItemIndex;
        if (levelItemIndex == null) {
          return;
        }
        let levelList = this.levelList[this.nameIndex];

        this.coachData.level = levelList[levelItemIndex];
        this.changeShowIndex();
      },

      certNameChanged() {
        let nameItemIndex = this.nameItemIndex;
        if (nameItemIndex == null) {
          this.nameIndex = 0;
          return;
        }

        this.levelItemIndex = null;
        this.coachData.name = this.nameList[nameItemIndex];
        this.nameIndex = nameItemIndex;
        this.changeShowIndex();
      },

      beforeRemoveFile(file, fileList) {
        return this.$confirm(`确定移除当前照片吗？`);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 ${ this.fileLimit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleFileRemove(file, fileList) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let index = this.coachData.photos.findIndex(function(item) {
          return item.url == url;
        });
        this.coachData.photos.splice(index, 1);
        if (this.coachData.photos.length < this.fileLimit) {
          // $("#idverify_view_outer .files-upload .el-upload--picture-card").show();
        }
        // this.updatepassportPhotos();
      },
      handlePreview(file) {
        let url = file.response;
        if (url == undefined) {
          url = file.url;
        }
        let photos = this.coachData.photos;
        let index = photos.findIndex(function(item) {
          return item.url == url;
        });
        if (index == -1) {
          index = 0;
        }
        this.dialogImageModel = {
          list: photos,
          index
        };
        this.dialogVisible = true;
      },

      handleUploadSuccess(res, file) {
        if (typeof res == 'string') {
          let name = file.name;
          let url = res;
          let obj = {
            name,
            url
          };
          this.coachData.photos.push(obj);
          if (this.coachData.photos.length >= this.fileLimit) {
            // $("#idverify_view_outer .files-upload .el-upload--picture-card").hide();
          }
          // this.updatepassportphotoss();
        }
      },

      deleteCardItem() {
        let _this = this;
        this.$confirm('您正在进行删除操作，删除后信息不会保存，需重新填写', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          _this.$emit('deleteItem', {
            index: _this.index
          });
        }).catch(() => {
          //...取消
          // console.log('不退出');
        });
      },
    }
  }
</script>

<style scoped>
  @import url("../../../../css/input-row.css");

  .coach-card-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .coach-card-view {
    margin-top: 50px;
  }

  .coach-card-view:first-child {
    margin-top: 20px;
  }

  .coach-card-view .delete-button {
    color: #999;
    text-decoration: underline;
  }

  .coach-card-view .delete-button:hover {
    color: #23527c;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/coachApplications/cards/CoachCardItem.vue